import {
  type Halloween2026Variant,
  getHalloween2026SlideKey,
  getHalloween2026Variant,
  resolveHalloween2026Variant,
} from '~/features/promotions/utils/get-halloween-2026-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

export const HALLOWEEN_2026_CAMPAIGN_ID = 'halloween-2026';

export const halloween2026CampaignCore: Pick<
  PromoCampaignSurfaceRenderers<Halloween2026Variant>,
  'id' | 'getSlideKey' | 'matches' | 'isGateReady' | 'resolve'
> = {
  id: HALLOWEEN_2026_CAMPAIGN_ID,
  getSlideKey: ({ resolved }) => getHalloween2026SlideKey(resolved),
  matches: ({ forcedPromotionId, promotionId }) =>
    getHalloween2026Variant(forcedPromotionId) != null || getHalloween2026Variant(promotionId) != null,
  isGateReady: ({ forcedPromotionId, promotionFetched }) =>
    getHalloween2026Variant(forcedPromotionId) != null || promotionFetched,
  resolve: ({ forcedPromotionId, promotionId }) => resolveHalloween2026Variant(forcedPromotionId, promotionId),
};
